import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

const SwipeAgeUnit = ({
  open,
  onClose,
  value,
  onChange,
  title = "Satuan Usia",
}) => {
  const [selectedValue, setSelectedValue] = useState(value || 0);

  const ageUnits = [
    { value: 0, label: "Tahun" },
    { value: 1, label: "Bulan" },
  ];

  const handleSelect = (value) => {
    setSelectedValue(value);
  };

  useEffect(() => {
    onChange(selectedValue);
    onClose();
  }, [selectedValue]);

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
            onClick={onClose}
          />

          <motion.div
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-[9999] max-h-[70vh] flex flex-col shadow-2xl text-base"
          >
            <div className="flex flex-col gap-3 px-4 pt-4">
              <div className="flex w-full justify-center">
                <div className="bg-gray-200 w-[25%] h-1.5 rounded-full"></div>
              </div>
              <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
            </div>

            <div className="flex-1 p-3 overflow-y-auto">
              <div className="space-y-3">
                {ageUnits.map((unit) => (
                  <div
                    key={unit.value}
                    onClick={() => handleSelect(unit.value)}
                    className={`p-3 rounded-xl border cursor-pointer transition-all duration-200 ${
                      selectedValue === unit.value
                        ? "border-secondary bg-secondaryActive"
                        : "border-gray-200 hover:border-gray-300 hover:bg-gray-50"
                    }`}
                  >
                    <div className="flex items-center justify-between">
                      <p className="font-medium text-slate-700">{unit.label}</p>
                      <div
                        className={`w-5 h-5 rounded-full border flex items-center justify-center ${
                          selectedValue === unit.value
                            ? "border-secondary bg-secondary"
                            : "border-gray-300"
                        }`}
                      >
                        {selectedValue === unit.value && (
                          <div className="w-3 h-3 rounded-full bg-white"></div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SwipeAgeUnit;
